<template>
  <div class="locator-map" ref="mapDom"></div>
</template>

<script>
export default {
  name: 'LocatorMap',
}
</script>

<script setup>
import icoMarker from '~/assets/img/ico/ico-marker-map-light.svg'

const props = defineProps({
  locations: Array,
  options: {
    type: Object,
    default: {},
  },
})

const emit = defineEmits(['location-select'])

// Da plugin plugins/leaflet.client.js
const { $L } = useNuxtApp()

const map = ref(null)
const mapDom = ref(null)
const markers = ref([])

onMounted(() => {
  initMap()
  setMarkers()
  setBounds()
})

onBeforeUnmount(() => {
  map.value.remove()
})

const initMap = () => {
  map.value = $L.map(mapDom.value, props.options)

  // https://alexurquhart.github.io/free-tiles/
  $L.tileLayer(
    'http://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}'
  ).addTo(map.value)
}

const setMarkers = () => {
  var marketIcon = L.icon({
    iconUrl: icoMarker,
    iconSize: [20, 24],
  })

  markers.value = props.locations.map((location) => {
    const marker = $L.marker([location.latitude, location.longitude], {
      icon: marketIcon,
    })
    marker.on('click', (e) => {
      scrollToLocation(location.id)
      emit('location-select', location.id)
    })
    marker.addTo(map.value)
    return marker
  })
}

const setBounds = () => {
  var group = new L.featureGroup(markers.value)
  map.value.fitBounds(group.getBounds())
}

const scrollToLocation = (id) => {
  var target = document.getElementById(id)
  target.scrollIntoView({ behavior: 'smooth' })
}
</script>

<style lang="scss">
@import './style.scss';
</style>
